module.exports = "/_next/static/images/Scale-7394b61a9816ee8bdb6250c524759efb.webp";